import { Controller } from "@hotwired/stimulus"
import { loadPresets, preset } from "../lib/animation_presets.ts"

/**
 * Le panneau Animations d'un bloc : charge les presets, ouvre et ferme la grille des types,
 * et pose l'animation choisie. Une nouvelle animation prend le côté de la précédente
 * (`data-side` du panneau) : en sortie, c'est la paire du type qui est posée. L'éditeur de
 * composition applique l'événement à l'habillage sélectionné.
 */
export default class extends Controller {
  static targets = ["grid", "gridToggle"]

  connect() {
    const json = this.element.dataset.presets
    if (json) loadPresets(json)
  }

  toggleGrid() {
    if (!this.hasGridTarget) return
    const open = this.gridTarget.hidden
    this.gridTarget.hidden = !open
    this.gridToggleTarget?.setAttribute("aria-expanded", String(open))
  }

  addAnim(e) {
    const picked = e.params?.preset || e.currentTarget.dataset.preset
    if (!picked) return

    const name = this.element.dataset.side === "out" ? preset(picked)?.pair || picked : picked
    const def = preset(name)
    if (!def) return

    const anim = {
      primitive: def.primitive,
      from: def.from,
      to: def.to,
      duration: def.duration,
      easing: def.easing,
      preset: name,
    }
    // Un balayage naît à la première couleur de charte du porteur.
    if (def.options?.includes("color")) anim.color = this.element.dataset.defaultColor

    if (def.group === "exit") {
      anim.fromEnd = true
      anim._fromEndDelay = 0
    } else {
      anim.delay = 0
    }

    window.dispatchEvent(new CustomEvent("overlay:add-anim", {
      detail: { anim },
    }))
  }
}
